import React from 'react';

import Data from 'data';
import { WithItemTooltip } from 'tooltip';
import { getIconPath } from 'common';

import './CollectionView.scss';

export default function CollectionView({ type }) {
  const data = Data.collections[type];
  if (!data) return null;
  return (
    <div className="lap-CollectionRewards">
      {Object.entries(data).map(([points, {id, count}]) => {
        const item = Data.items[id];
        if (!item || !item.icon) return null;
        return (
          <WithItemTooltip item={id}>
            <div key={points} className={`lap-collection-item lap-item-${Data.itemGrades[item.grade || 0].color}`}>
              <div className="lap-header">{points} <span className={`lap-token-icon lap-token-${type}`}/></div>
              <div className="lap-icon">
                <span className="lap-image" style={{backgroundImage: `url(${getIconPath(item.icon)})`}}>
                  {count > 1 && <span className="lap-count">{count}</span>}
                </span>
              </div>
              <div className="lap-name">{item.name}</div>
            </div>
          </WithItemTooltip>
        );
      })}
    </div>
  );
}
